import axios from 'axios'
import React, { useEffect, useState } from 'react'
import ShopItemListType1 from '../../../components/ShopItemListType1'
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { useTheme } from '@mui/material';
import ShopMenuList from './ShopMenuList';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import { TbLoader } from 'react-icons/tb';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import useWindowDimensions from '../../../utils/useWindowDimensions';
import { useDispatch, useSelector } from 'react-redux';
import { setOrderAll } from '../../../redux/pageSlice';

const useStyles = makeStyles((theme)=>({

  shopListBlock:{
    minHeight: 1000,
    fontFamily:[
      'Noto Sans KR'
    ],
  },
  listFlexDiv:{
    display:'flex',
    justifyContent: 'space-between',
    alignContent: 'flex-end',
    maxWidth:'1200px',
    margin:'0 auto',
    padding:'180px 30px 0 30px ',

    [theme.breakpoints.down(1025)]: {
      maxWidth:'750px',      
      padding:'50px 20% 0 20% ',
    },
    [theme.breakpoints.down(425)]: {
      padding:'50px 5% 0 5%'
    },

  },
  listDiv:{
    borderRight:'1px solid #AAA',
    color:'#555',
    cursor:'pointer',
    padding:'0 10px',
    fontSize:'14px',
    '&:last-child':{
      borderRight:'none',
      paddingRight:'0',
    },
    '&:first-child':{
      paddingLeft:'0',
    },
    '&:hover':{
      color:'#AAA'
    },
    [theme.breakpoints.down(960)]: {
      fontSize:'10px',
    },
  },
  load:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  },
  loadingIcon:{
    color:'#007235',
    fontSize:'50px',
    animation:'$loadSpin 5s infinite'
  },
  "@keyframes loadSpin":{
    from: { transform:'rotate(0deg)' },
    to: { transform:'rotate(1turn)' }
  },
}));


const ShopList = () => {
  const dispatch = useDispatch()
  const orderAll = useSelector(state => state.page.orderAll);
  const theme = useTheme();
  const classes = useStyles(theme);
  const { width } = useWindowDimensions();
  const location = useLocation();
  const [data, setData] = useState([])
  const [caId, setCaId] = useState('')
  const [orderType, setOrderType] = useState('1')
  const [dialog, setDialog] = useState('');
  const [loading, setLoading] = useState(false)
  const orderList = [
    // {order: '1', name: '최신순'},
    {order: '3', name: '낮은가격순'},
    {order: '4', name: '높은가격순'},
    {order: '2', name: '상품명순'},
    // {order: '5', name: '낮은조회순'},
    // {order: '6', name: '높은조회순'},
  ]
  
  useEffect(() => {
    setCaId(location.state.caId)
  }, [location.state.caId])

  const getShopItems = async() => {
    try {
      setLoading(true)
      const res = await axios.get(`/api/shop/shopList/${caId}/${orderAll}/`)
      if(res.data.success === false) {
        setDialog('불러오기 실패')
        setLoading(false)
        return
      }
      setData(res.data.result)
      setLoading(false)

    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }



  useEffect(() => {
    if(caId !== ''){
      getShopItems()
    }
  } , [caId, orderType])

  useEffect(() => {

    setOrderType(orderAll)

    return () => {
      setData([])
    }
  }, [])


  return (
    <div className={classes.shopListBlock}>
      <ShopMenuList caId={caId}/>
        <div className={classes.listFlexDiv}>
          <p style={{color:'#555', fontSize:'14px'}}>총 {data.length}개</p>
          <div style={{display:'flex', justifyContent: 'flex-end', alignItems: 'flex-end'}}>
            {orderList.map((item)=>(
            <div 
              key={item.order} 
              onClick={() => {
                dispatch(setOrderAll(item.order))
                setOrderType(item.order)
              }}
              className={classes.listDiv}
            >
              {item.name}
            </div>
            ))}
          </div>
        </div>
        {loading ? (
          <div className={classes.load}>
            {[1,2,3,4].map((itm) => {
                      if (width < 600) return (
                        <div
                          style={{margin: 3, display: itm%2 ===0 && 'none'}}
                        >
                          <div
                              style={{ width: 160, height: 160}}
                            >
                              <Skeleton
                                height="100%"
                                width="100%"
                                containerClassName="avatar-skeleton"
                              />
                          </div>
                          <div
                            style={{ width: 160, height: 100}}
                          >
                            <Skeleton count={3} /> 
                          </div>
                      </div>
                      )

                      return (<div
                        style={{margin: 5}}
                      >
                        <div
                            style={{ width: 270, height: 270}}
                          >
                            <Skeleton
                              height="100%"
                              width="100%"
                              containerClassName="avatar-skeleton"
                            />
                        </div>
                        <div
                          style={{ width: 270, height: 100}}
                        >
                          <Skeleton count={3} /> 
                        </div>
                    </div>)
            })}
          </div>
        ) : data.length > 0 && <ShopItemListType1 data={data} /> }



          <Dialog
            open={dialog === '' ? false : true}
            onClose={() => setDialog('')}
          >
            <DialogTitle id="alert-dialog-title">
              {dialog}
            </DialogTitle>
            <DialogActions>
              <Button onClick={() => setDialog('')} autoFocus>
                확인
              </Button>
            </DialogActions>
          </Dialog>
    </div>
  )
}

export default ShopList
